





























import AddTypeImg from '@/components/image/AddTypeImg.vue'
import ListItem from '@/components/list/ListItem.vue'
import Translation from '@/mixins/Translation'
import {Watch} from '@@/node_modules/vue-property-decorator'
import {Component, Mixins, Prop} from 'vue-property-decorator'
import BttPopup from '@/components/popup/btt/BttPopup.vue'

interface AddType {
  title: string
  value: 'cert' | 'add' | 'enter'
}

/**
 * @displayName BankAddTypeSelectionPopup
 * 은행 추가(연동) 시 공동인증서 연동 방식 선택, 출금계좌 추가 방식 선택
 */
@Component({
  components: {AddTypeImg, ListItem, BttPopup},
})
export default class BankAddTypeSelectionPopup extends Mixins(Translation) {
  @Prop({default: 'terms', type: String}) translation: string
  @Prop({default: false, type: Boolean}) value: boolean
  @Prop({default: '', type: String}) title: string
  @Prop({default: () => ([]), type: Array}) list: AddType[]
  @Prop({default: true, type: Boolean}) hasImg: boolean

  open: boolean = true

  @Watch('value', {immediate: true})
  __value(value) {
    this.open = value
  }

  @Watch('open', {immediate: true})
  __open(value) {
    this.$emit('input', value)
  }

  onClick(value) {
    this.$emit('type-selected', value)
    // TODO: api condition
    this.close()
  }

  close() {
    this.open = false
  }
}
